module.exports = __webpack_public_path__ + "img/20.2a15a34.jpg";